import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/apiClient";
import { RefreshCw, Trash2 } from "lucide-react";
import { money } from "../lib/finance";
import { PageTitle, Empty } from "./common";
import { DaysBadge, TrashOtherList } from "./TrashOther";

const TABS = [["policy", "Poliçeler"], ["customer", "Müşteriler"], ["quote", "Teklifler"], ["appointment", "Randevular"]];

function PolicyTrash({ trashPolicies, onRestore, onPermanentDelete }) {
  if (trashPolicies.length === 0) return <Empty text="Silinen poliçe yok. Silinen poliçeler buraya düşer ve 30 gün saklanır." />;
  return (
    <div className="panel">
      <table className="data-table" data-testid="trash-table">
        <thead><tr><th>Poliçe No</th><th>Müşteri</th><th>Branş</th><th>Prim</th><th>Silinme Tarihi</th><th>Kalıcı Silinmeye</th><th style={{ textAlign: "right" }}>İşlem</th></tr></thead>
        <tbody>
          {trashPolicies.map((p) => (
            <tr key={p.id} data-testid={`trash-row-${p.id}`}>
              <td><strong>{p.policeNo || "—"}</strong></td>
              <td>{p.customer || "—"}</td>
              <td>{p.branch || "—"}</td>
              <td>{p.premium ? money(p.premium) : "—"}</td>
              <td className="small muted">{p.deletedAt ? new Date(p.deletedAt).toLocaleString("tr-TR") : "—"}</td>
              <td><DaysBadge iso={p.deletedAt} /></td>
              <td style={{ textAlign: "right" }}>
                <div style={{ display: "flex", gap: 6, justifyContent: "flex-end", flexWrap: "wrap" }}>
                  <button className="primary-button small" data-testid={`trash-restore-${p.id}`} onClick={() => onRestore(p.id)}><RefreshCw size={14} /> Geri yükle</button>
                  <button className="ghost-button danger" data-testid={`trash-purge-${p.id}`} onClick={() => onPermanentDelete(p.id)} title="Kalıcı sil"><Trash2 size={14} /></button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function TrashPage({ trashPolicies, loadTrash, onRestore, onPermanentDelete, onItemRestored }) {
  const [tab, setTab] = useState("policy");
  const [counts, setCounts] = useState({});
  const [nonce, setNonce] = useState(0);
  const onCount = useCallback((items) => setCounts(items.reduce((a, i) => ({ ...a, [i.kind]: (a[i.kind] || 0) + 1 }), {})), []);
  useEffect(() => { axios.get(`${API}/trash/items`).then(({ data }) => onCount(data || [])).catch(() => {}); }, [nonce, onCount]);
  const count = (k) => (k === "policy" ? trashPolicies.length : counts[k] || 0);
  return (
    <div className="space-y-8" data-testid="trash-page">
      <PageTitle eyebrow="Yönetim" title="Çöp Kutusu" description="Son 30 gün içinde silinen poliçeler, müşteriler, teklifler ve randevular. Bu süre sonunda kalıcı olarak silinir; istediğiniz zaman geri yükleyebilirsiniz."
        action="Yenile" actionTest="trash-refresh-button" onAction={() => { loadTrash(); setNonce((n) => n + 1); }} />
      <div className="chip-row trash-tabs" data-testid="trash-tabs">
        {TABS.map(([k, l]) => (
          <button key={k} type="button" className={`chip ${tab === k ? "chip-active" : ""}`} onClick={() => setTab(k)} data-testid={`trash-tab-${k}`}>{l} · {count(k)}</button>
        ))}
      </div>
      {tab === "policy"
        ? <PolicyTrash trashPolicies={trashPolicies} onRestore={onRestore} onPermanentDelete={onPermanentDelete} />
        : <TrashOtherList key={`${tab}-${nonce}`} kind={tab} onRestored={onItemRestored} onCount={onCount} />}
    </div>
  );
}
